<template>
  <vx-card title="Exception">
    <div class="vx-row mb-6 w-1/2">
      <div class="vx-col sm:w-1/4 flex items-center">
        <span>Code</span>
      </div>
      <div class="vx-col sm:w-3/4 w-full">
        <vs-input class="w-full" type="text" v-model="exception" readonly />
      </div>
    </div>
    <div class="vx-row mb-6 w-1/2">
      <div class="vx-col sm:w-1/4 flex items-center">
        <span>Sales</span>
      </div>
      <div class="vx-col sm:w-3/4 w-full">
        <vs-input class="w-full" type="text" v-model="sales" readonly />
      </div>
    </div>
    <div class="vx-row w-1/2 mt-2">
      <div class="vx-col sm:w-1/4 flex items-center">
        <span>Notes</span>
      </div>
      <div class="vx-col sm:w-3/4 w-full">
        <vs-textarea class="w-full" v-model="data.notes" />
      </div>
    </div>

    <vs-divider style="width: 100%; margin-left: 0%">Attachment</vs-divider>
    <div class="vx-row mb-3 mt-6 w-4/4" style="width: 100%; margin-left: 0%">
      <div class="vx-col sm:w-1/3 w-full">
        <span>File</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <div class="vx-col sm:w-4/5 w-full">
          <input
            id="fileInput"
            name="file"
            class="w-full inputx"
            type="file"
            ref="file"
            accept=".jpg, .jpeg, .png, .pdf"
            multiple
          />
        </div>
      </div>
    </div>

    <div class="vx-row mb-3 mt-6 w-4/4" style="width: 100%; margin-left: 0%">
      <div class="vx-col sm:w-1/3 w-full">
        <span></span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <div class="vx-col sm:w-4/5 w-full">
          <vs-button class="mr-3 mb-2" @click="handleAttachment"
            >Add Attachment</vs-button
          >
        </div>
      </div>
    </div>

    <vs-divider style="width: 100%; margin-left: 0%"
      >List Attachment</vs-divider
    >
    <div class="vx-row mb-3 mt-6 w-4/4" style="width: 100%; margin-left: 0%">
      <table class="vs-table vs-table--tbody-table">
        <template v-for="(tr, i) in data.file">
          <tr
            class="tr-values vs-table--tr tr-table-state-null selected"
            v-bind:key="tr.name"
          >
            <td class="td vs-table--td">{{ tr.name }}</td>
            <td class="td vs-table--td">
              <vx-tooltip text="Download" v-if="tr.path != ''">
                <vs-button
                  type="line"
                  icon-pack="feather"
                  @click.stop="downloadFileAwsS3(tr.path)"
                  icon="icon-download"
                />
              </vx-tooltip>
            </td>
            <td class="td vs-table--td">
              <template>
                <vx-tooltip text="Delete">
                  <vs-button
                    type="line"
                    icon-pack="feather"
                    @click.stop="handleDeleteAttachment(i, tr.id)"
                    icon="icon-trash"
                  />
                </vx-tooltip>
              </template>
            </td>
          </tr>
        </template>
      </table>
    </div>
    <vs-divider style="width: 100%; margin-left: 0%"></vs-divider>

    <vs-popup title="Preview" :active.sync="showAttachment" :fullscreen="true">
      <iframe
        v-if="showAttachment"
        :src="attachmentPath"
        style="width: 100%; height: 80dvh"
      />
    </vs-popup>

    <div class="vx-row my-4">
      <div class="vx-col flex items-center gap-2">
        <vs-button
          @click="handleSubmitWithoutApproval"
          size="small"
          color="primary"
          icon-pack="feather"
          icon="icon-save"
        >
          Save</vs-button
        >

        <vs-button
          @click="handleSubmitApproval"
          size="small"
          color="primary"
          icon-pack="feather"
          icon="icon-save"
        >
          Save & Send Approval</vs-button
        >

        <vs-button
          @click="onClickBack()"
          size="small"
          color="danger"
          icon-pack="feather"
          icon="icon-x"
          >Cancel</vs-button
        >
      </div>
    </div>
  </vx-card>
</template>

<script>
import moment from "moment";
import { formatNumber } from "../../../utils/common";

export default {
  data() {
    return {
      table: this.tableDefaultState(),
      total_value: 0,
      territory: null,
      sales: null,
      exception: null,
      routes: [],
      id: null,
      data: {
        exception_id: null,
        personal_id: null,
        personal_name: "",
        territory_id: null,
        date: null,
        file: [],
        fileUrl: '',
        notes: null,
        nilai_cit: 0,
        nilai_cit_handover: 0,
        jumlah_invoice: 0,
        jumlah_invoice_handover: 0,
        cit_code: null,
        cit_date: null,
        cit_billing_code: null,
        cit_billing_date: null,
      },
      fileAttactment: {
        multiple: true,
        disabled: false,
        value: null,
        preview: null,
        accepted_types: ["jpg", "jpeg", "png", "pdf", "doc", "docx", "xls", "xlsx"],
        files: [],
      },
      history_notes: "",
      status: 0,
      showAttachment: false,
      attachmentPath: "",
      attachment_ids: [],
      fileShow: false,
    };
  },
  mounted() {
    const personalId = this.$route.query.personal_id;
    const personalName = this.$route.query.personal_name;
    const territoryId = this.$route.query.territory_id;

    this.id = this.$route.query.exception_id
    this.sales = personalName
    this.data.personal_id = personalId
    this.data.personal_name = personalName
    this.data.territory_id = territoryId
    this.data.date = this.$route.query.date
    this.getDataCIT();
  },
  methods: {
    getDataCIT() {
      this.$vs.loading();
      this.$http
        .get("/api/sfa/v1/daily-closing-salesman/get-data-cit", {
          params: {
            territory_id: parseInt(this.data.territory_id),
            personal_id: parseInt(this.data.personal_id),
            date: this.data.date,
          },
        })
        .then((resp) => {
          console.log("DATA CIT", resp);
          if (resp.code == 200) {
            this.data.nilai_cit = resp.data.records.nilai_cit;
            this.data.nilai_cit_handover = resp.data.records.nilai_cit_handover;
            this.data.jumlah_invoice = resp.data.records.jumlah_invoice;
            this.data.jumlah_invoice_handover = resp.data.records.jumlah_invoice_handover;
            this.data.cit_code = resp.data.records.cit_code;
            this.data.cit_date = resp.data.records.cit_date;
            this.data.cit_billing_code = resp.data.records.cit_billing_code;
            this.data.cit_billing_date = resp.data.records.cit_billing_date;
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
        });
    },
    tableDefaultState() {
      return {
        data: [],
      };
    },
    onClickBack() {
      this.$router.push({
        name: "salesman",
      });
    },
    // async previewAttachment(path) {
    //     const url = await this.previewFileAwsS3(path);
    //     if (url) {
    //         this.attachmentPath = url;
    //         this.showAttachment = true;
    //     }
    // },
    handleDeleteAttachment(index, id) {
        this.data.file = this.data.file.filter((item, i) => i != index);
        this.deleteFile(id);
    },
    handleAttachment() {
        if (this.$refs.file.files[0]) {
            let a = this.$refs.file.files
            for (let i = 0; i < a.length; i++) {
            if(a[i].size <= 5000000){ // 5mb
                this.file = a[i];
                this.uploadData();
            } else {
                this.$vs.notify({
                title: "Error",
                text: a[i].name + " is greater than 5MB",
                color: "danger",
                position: "top-right",
                iconPack: "feather",
                icon: "icon-check",
                });
            }
            }
            document.querySelector("#fileInput").value = "";
        } else {
            this.$vs.notify({
            title: "Error",
            text: "No file chosen.",
            color: "danger",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-check",
            });
        }
    },
    paramUpload() {
        var form = new FormData();
        form.append("id", this.id);
        form.append("file", this.file);
        form.append("type", this.file.type);
        return form;
    },
    uploadData() {
      this.$vs.loading();
      this.$http
          .post("/api/sfa/v1/daily-closing-salesman/upload-file", this.paramUpload(), {
          headers: {
              "Content-Type": "multipart/form-data",
          },
          })
          .then((resp) => {
          this.$vs.loading.close();
          console.log("RESP ATTACHMENT",resp)
          if (resp.code == 200) {
              this.data.file.push({
              id: resp.data.attachment.id,
              name: resp.data.attachment.NameFile,
              path: resp.data.attachment.PathFile,
              doc_type: resp.data.attachment.DocType,
              });
              this.attachment_ids.push(parseInt(resp.data.attachment.id))
              this.$vs.notify({
              color: "success",
              title: "Success",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
              });
          } else {
              this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
              });
          }
          })
          .catch((error) => {
          console.log(error)
          this.$vs.loading.close();
          });
      },
      deleteFile(id) {
        this.$vs.loading();
        var form = new FormData();
        form.append("id", id);
        this.$http
            .post("/api/sfa/v1/daily-closing-salesman/delete-file", form, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            })
            .then((resp) => {
            this.$vs.loading.close();
            if (resp.code == 200) {
                this.$vs.notify({
                color: "success",
                title: "Success",
                text: resp.message,
                position: "top-right",
                iconPack: "feather",
                icon: "icon-x-circle",
                });
            } else {
                this.$vs.notify({
                color: "danger",
                title: "Error",
                text: resp.message,
                position: "top-right",
                iconPack: "feather",
                icon: "icon-x-circle",
                });
            }
            })
            .catch((error) => {
            console.log(error)
            this.$vs.loading.close();
        });
    },
    paramData() {
      return {
        territory_id: parseInt(this.data.territory_id),
        personal_id: parseInt(this.data.personal_id),
        personal_name: this.data.personal_name,
        date: this.data.date,
        status: this.status,
        notes: this.data.notes,
        attachment_ids: this.attachment_ids,
        nilai_cit: this.data.nilai_cit,
        nilai_cit_handover: this.data.nilai_cit_handover,
        jumlah_invoice: this.data.jumlah_invoice,
        jumlah_invoice_handover: this.data.jumlah_invoice_handover,
        cit_code: this.data.cit_code,
        cit_date: this.data.cit_date,
        cit_billing_code: this.data.cit_billing_code,
        cit_billing_date: this.data.cit_billing_date,
      };
    },
    postData() {
      console.log('param data',this.paramData())
      if (!this.attachment_ids || this.attachment_ids.length === 0) {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "Attachment is required.",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
        return;
      }

      this.$vs.loading();
      this.$http
      .post("/api/sfa/v1/daily-closing-salesman/create", this.paramData())
      .then((resp) => {
          if (resp.code == 200) {
          this.$vs.loading.close();
          this.$vs.notify({
              color: "success",
              title: "Success",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
          });
          this.onClickBack();
          } else {
          this.$vs.loading.close();
          this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
          });
          }
      })
      .catch((error) => {
          console.log(error)
          this.$vs.loading.close();
      });
    },
    handleSubmitWithoutApproval() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Please confirm to create document",
        accept: () => {
          this.handleSubmit();
        },
      });
    },
    handleSubmit(sendApproval = false) {
      console.log("ID",this.id)
      if (sendApproval == true) {
          this.status = 1;
      }

      this.postData();
      // this.postData();
    },
    handleSubmitApproval() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Please confirm to create & send to approval",
        accept: () => {
          this.handleSubmit(true);
        },
      });
    },
  },
  filters: {
    formatNumber(value) {
      return formatNumber(value);
    },
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("DD-MM-YYYY");
      }
    },
  },
};
</script>
